import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

type Breakpoints = 'sm' | 'md' | 'lg' | 'xl' | '2xl'

export default (breakpoint: Breakpoints = 'md') => {
  const isSmaller: Ref<boolean> = useBreakpoints(breakpointsTailwind).smaller(breakpoint)
  return isSmaller
}
